var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mostrarBotaoProtecao)?_c('span',[_c('button',{class:[
      _vm.classe,
      _vm.dadosMascarados ? 'protecao-exibir' : 'protecao-cobrir',
      { 'pulso-protecao': _vm.deveChamarAtencao }
    ],attrs:{"type":"button","disabled":_vm.telaBloqueada,"title":_vm.textoDeApoio},on:{"click":_vm.togglePresentation}},[_c('i',{class:[
        _vm.dadosMascarados ? 'fas fa-eye-slash' : 'fas fa-eye',
        { 'menu-icon icon-lg': _vm.modoMenu }
      ]}),(!_vm.modoMenu)?_c('span',[_vm._v(" "+_vm._s(_vm.dadosMascarados ? "Exibir dados pessoais" : "Ocultar dados pessoais")+" ")]):_vm._e()]),_c('modal-verificacao-acao',{ref:"verificacaoAcao"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }